document.addEventListener('DOMContentLoaded', function() {
  let loading = false;
  let nextPageUrl = document.querySelector('.pagination__next') ? document.querySelector('.pagination__next').getAttribute('href') : null;

  // Function to show the loader
  function showLoader() {
    document.getElementById('infinite-scroll-loader').style.display = 'block';
  }

  // Function to hide the loader
  function hideLoader() {
    document.getElementById('infinite-scroll-loader').style.display = 'none';
  }

  // Function to hide pagination
  function hidePagination() {
    const pagination = document.querySelector('.pagination-wrapper');
    if (pagination) {
      pagination.style.display = 'none';
    }
  }

  window.addEventListener('scroll', () => {
    if (loading || !nextPageUrl) return;

    // Trigger before the user reaches the bottom so newly loaded products are
    // already visible. Buffer scales with the viewport (min 1500px) so it works
    // on tall screens and fast scrolls too.
    const triggerBuffer = Math.max(2500, window.innerHeight * 10);
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - triggerBuffer) {
      loading = true;
      showLoader();
      hidePagination();

      fetch(nextPageUrl)
        .then(response => response.text())
        .then(data => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, 'text/html');
          let newProducts = doc.querySelector('#product-grid');
          let newPagination = doc.querySelector('.pagination__next');

          if (newProducts) {
            const grid = document.querySelector('#product-grid');
            // Append the new <li> items, not the whole <ul> (which would nest
            // a <ul> inside #product-grid). Move nodes out of the parsed grid.
            while (newProducts.firstElementChild) {
              grid.appendChild(newProducts.firstElementChild);
            }
          }

          nextPageUrl = newPagination ? newPagination.getAttribute('href') : null;
          hideLoader();
          loading = false;
        })
        .catch(error => {
          console.error('Error fetching next page:', error);
          hideLoader();
          loading = false;
        });
    }
  });
});
